import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const getTest = async ({id}) => {
    const params = new URLSearchParams({
        "test_id": id,
    });

    return axios
        .get(`/wp-json/api/adpt/test?${params.toString()}`)
        .then((res) => res?.data);
};

export default function useTest({ id }) {

    return useQuery(
        ["test", { id }],
        () => getTest({ id }),
        {
            enabled: !!id,
            keepPreviousData: true,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
        }
    );
}
